// services
import { AxiosInstance } from 'axios';
import AxiosInstanceCreator from 'services/api';

// models
import { BaseApiResponse } from 'modules';
import { ReqChangePassword, ReqChangePasswordForce, ReqLogin, ResLogin } from 'domains/Auth';
import { ReqForgotPassword } from '../models/forgot-password.model';

export class LoginAPI {
  Axios: AxiosInstance;

  constructor() {
    this.Axios = new AxiosInstanceCreator().create();
  }

  async login(request: ReqLogin): Promise<BaseApiResponse<ResLogin>> {
    return this.Axios.post(`/auth/token/password`, request).then((res) => res.data);
  }

  async changePassword(request: ReqChangePassword): Promise<BaseApiResponse> {
    return this.Axios.put(`/user/temp-pwd`, request).then((res) => res.data);
  }

  async forgotPassword(request: ReqForgotPassword): Promise<BaseApiResponse> {
    return this.Axios.get(`/user/temp-pwd`, { params: request }).then((res) => res.data);
  }

  async changePasswordForce(request: ReqChangePasswordForce): Promise<BaseApiResponse> {
    const { userId, ...rest } = request;
    return this.Axios.put(`/user/${userId}/password`, rest).then((res) => res.data);
  }
}
